// extracted by mini-css-extract-plugin
export var audioPlayer = "_ol-0";